import request from "@/common/utils/request.js";
import { getInfo, getDomain } from "@/api/cookies";

import { WebClient } from "@/api/webClient";
import data from "area-data";
const webClient = new WebClient();
export class BaseClient extends WebClient {
  
    //学习工具
    async getStore(entrants_type) {
        return await request({
            url: "/ucenter/business/getStore",
            method: "GET",
            params: {
                status: 0,
                entrantsType: entrants_type,
            },
        });
    }
    async checkVersion(params) {
        const data = await request({
            url: `/system/index/appVersion/paginationTenant`,
            method: "POST",
            data:params,
        });
        return data;
    }
    async checkJXTVersion(params) {
        const data = await request({
            url: `/system/pc/systemData/getAndroidDownloadPackageNew`,
            method: "GET",
            params:params,
        });
        return data;
    }

    /** 
     * 轮播图
     */
    getSurfaceList(type) {
        const data = request({
            url: `/system/sysFirst/qbsBoard`,
            method: "GET",
            params: {
                callKey: type
            },
        });
        return data;
    }
    /* 师资力量分页列表 */
    async selectPCPageList(params) {
        let data = await request({
            url: "/outside/teachBasics/qbsTeacherInfo",
            method: "POST",
            data:params,
        });
        return data;
    }
    /* 师资力量分页列表 */
    async getPcById(params) {
        let data = await request({
            url: "/outside/teachBasics/getTeacherInfoById",
            method: "GET",
            params:params,
        });
        return data;
    }
    /* 查询老师答疑 */
    async selectStuQuestionsList(params) {
        let data = await request({
            url: "/teach/mobile/qAOnTestQuestions/getAnswerQuestionByTeacherId",
            method: "GET",
            params:params,
        });
        return data;
    }
    // 个人中心 基本资料 修改信息
    updatePcUser(as, bs, cs, ds, es, fs, gs, hs, is, js, ks) {
        return request({
            url: '/system/user/modifyUserInfo',
            method: 'POST',
            data: {
                userId: as,
                nickName: bs,
                tel: cs,
                sex: ds,
                address: es,
                headPortrait: fs,
                birthday: gs,
                personalSignature:hs,
          
            }   
        })
    }
    // 获取省市区
    getAreaListByParentId(params) {
        return request({
            url: '/system/dictionary/getAreaDataChild',
            method: "GET",
            params:params,
        });
    }  
    // 修改收货地址
    updateStuShopAddress(data) {
        return request({
            url: '/system/pc/personalCenter/addAddressManagement',
            method: "POST",
            data,
        });
    } 
    // 获取收货地址
    getUserAddress(params) {
        return request({
            url: '/system/pc/personalCenter/getAddressManagementByUserId',
            method: "GET",
            params:params,
        });
    }
    // 删除收货地址
    delStuShopAddress(params) {
        return request({ 
            url: '/system/pc/personalCenter/deleteAddressById',
            method: "GET",
            params: params,
        });
    }
    /**pc端兑换券 兑换 */
    async studentExchange(code) {
        let data = await request({
            url: '/marketing/couponApi/coinCertificate',
            method: "POST",
            params: {
                code: code
            },
        });
        return data;
    }
    //学生添加反馈消息
    async saveFeedback(content, type, pictureList) {
        let data = await request({
            url: "/teach/feedbackApi/addFeedback",
            method: "POST",
            data: {
                content: content,
                type: type,
                pictureList: pictureList,
                source:2
            },
        });
        return data;
    }
    // 个人中心 基本资料 修改手机号
    modifyRedundancyPhone(mobile, sjToken) {
        return request({
            url: '/system/user/modifyRedundancyPhone',
            method: 'POST',
            data: {
                phone: mobile,
                userId: sjToken
            }
        })
    }
    // 个人中心 基本资料 修改密码
    restPassword(password, sjToken) {
        return request({
            url: '/system/user/restPassword',
            method: 'POST',
            data: {
                password: password,
                userId: sjToken
            }
        })
    }
    /* 学习卡对应的知识套餐列表 */
    getActStudyProductList(params) {
        const data = request({
            url: '/marketing/jxy/studycard/getActStudyProductList',
            method: "POST",
            data: params,
        });
        return data;
    }
    /* 学习卡激活 */
    activeStudyCardt(params) {
        const data = request({
            url: '/marketing/jxy/studycard/activeStudyCard',
            method: "POST",
            params: params,
        });
        return data;
    }
    // 获取的收藏班型列表
    async getCollectKnowledgeList() {
        const data = await request({
            url: `/knowledge/collect/getCollectKnowledgeList`,
            method: "GET",
            params: {type:'5'},
        });
        return data;
    }
    // 获取我的消息
    getMessagePcList() {
        return request({
            url: '/system/message/getMessagePcList',
            method: 'GET',
            params: {
                noticeType: '1',
            }
        })
    }
    /** 修改当前学生消息状态(转为已读)*/
    updateMessageRead(messageId) {
        return request({
            url: "/system/message/updateMessageRead",
            method: "POST",
            data: {
                messageId: messageId,
            },
        });
    }
    /** 个人中心 获取学生订单信息*/
    getPayOrdersList(payStatusCode) {
        return request({
            url: "/orders/pay/getPayOrdersList",
            method: "POST",
            data: {
                payStatusCode: payStatusCode,
            },
        });
    }
    /**pc获取学生当前优惠券
    *  couponType 1：无门槛券 2：满减券' 4折扣券,
    *  type 是否使用 （1:可用 2：已用 3：过期）
    */
    async getMyCouponList(couponType,type) {
        let data = await request({
            url: '/marketing/couponApi/getMyCouponList/v2',
            method: "GET",
            params: {
                type: type + 1,
                couponType:couponType=='3'? '4':couponType,
                pageNum:1,
                pageSize:999
            },
        });
        return data;
    }
    /**pc端优惠券列表--领券中心--列表 */
    async getDiscountPcList(userId) {
        let data = await request({
            url: '/marketing/couponApi/getWxCouponList',
            method: "GET",
            params: {
                userId:userId,
                couponType:'',
                pageNum:1,
                pageSize:999
            },
        });
        return data;
    }
    /**pc端优惠券列表--领券中心--领取 */
    async getReceiveCoupon(couponId) {
        let data = await request({
            url: '/marketing/couponApi/receiveCoupon',
            method: "GET",
            params: {
                couponId:couponId
            },
        });
        return data;
    }
    /* 我的提问列表 */
    selectStuPcQuestionsList(params) {
        const data = request({
            url: '/teach/question/getMyAskQuestionList',
            method: "GET",
            params,
        });
        return data;
    }
    /* 查询老师答疑 */
    async getWorkQuestionList(params) {
        let data = await request({
            url: "/teach/work/ask/getWorkQuestionList",
            method: "GET",
            params:params,
        });
        return data;
    }
    /* 查询试题/课程老师答疑 */
    async getMyAskQuestionById(params) {
        let data = await request({
            url: "/teach/question/getMyAskQuestionById",
            method: "GET",
            params:params,
        });
        return data;
    }
    
    // 获取用户的反馈列表
    async getFeedbackListByUser() {
    return await request({
      url: `/teach/feedbackApi/getMyFeedbackList`,
      method: 'GET'
    });
  }
}
